/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IHorribleHeroesGameData, IHorribleHeroesServerData} from "./data/IHorribleHeroesServerData";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";

export class HorribleHeroesServerDataParser extends SpinServerDataParser {
    private infectiousPos: number[][];
    private _mysterySymbolSizes: number[];
    private _numberOfExpandSymbolOnReel: number[];

    public parseBetWinsInit(rawData: IHorribleHeroesServerData): IBetLineWinData[] | IBetWayWinData[] | undefined {
        switch (HorribleHeroesGameConfig.instance.BET_WIN_MODE) {
            case 1 /* BET_LINE */
            :
                return rawData.betLineWins;
            case 2 /* BET_WAY */
            :
                if (rawData.betWayWins) {
                    rawData.betWayWins!.forEach((value) => {
                        // to handle winPositions at client end #207
                        value.reelWinPositions = [...this.parseBetWayWins([...value.reelWinPositions], rawData!)];
                    });
                }
                return rawData.betWayWins;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public parseBetWinsBeforeXways(rawData: IHorribleHeroesServerData): IBetLineWinData[] | IBetWayWinData[] | undefined {
        switch (HorribleHeroesGameConfig.instance.BET_WIN_MODE) {
            case 1 /* BET_LINE */
            :
                return rawData.betLineWins;
            case 2 /* BET_WAY */
            :
                return JSON.parse(JSON.stringify(rawData.betWayWins));
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public parseBetWayWins(betReelWinPositions: boolean[][], rawData: IHorribleHeroesServerData): boolean[][] {
        let reelTempWinPosiions: boolean[][] = [[], [], [], [], []];
        betReelWinPositions.forEach((reelB: boolean[], reelId: number) => {
            reelB.forEach((isWin: boolean, symId: number) => {
                reelTempWinPosiions[reelId][symId] = isWin;
            });
        });
        betReelWinPositions.forEach((reelB: boolean[], reelId: number) => {
            let counter = 0;
            let counterFalse = 0;
            let initial = 1;
            let initialFalse = 1;
            reelB.forEach((isWin: boolean, symId: number) => {
                let condition = rawData.symbolSizes[reelId][symId];
                let conditionF = rawData.symbolSizes[reelId][symId];
                if (isWin) {
                    if (rawData.symbolSizes[reelId][symId]) {
                        if (counter > 0) {
                            initial = (rawData.symbolSizes[reelId][symId]) - 1; //2
                            condition = (2 * (rawData.symbolSizes[reelId][symId])) - 2; //5,6
                        }
                        for (let k = initial; k < condition; k++) {
                            reelTempWinPosiions[reelId].splice(symId + k, 0, true);
                            counter += 1;
                        }
                    }
                } else {
                    if (rawData.symbolSizes[reelId][symId]) {
                        if (counterFalse > 0) {
                            initialFalse = (rawData.symbolSizes[reelId][symId]) - 1; //2
                            conditionF = (2 * (rawData.symbolSizes[reelId][symId])) - 2; //5,6
                        }
                        for (let k = initialFalse; k < conditionF; k++) {
                            reelTempWinPosiions[reelId].splice(symId + k, 0, false);
                            counterFalse += 1;
                        }
                    }
                }
            });
        });
        return reelTempWinPosiions
    }

    public parseTotalNumberOfWays(rawData: IHorribleHeroesGameData): number {
        return rawData.totalNumberOfWays;
    }

    public parseExpandedSymbol(rawData: IHorribleHeroesGameData): string {
        return rawData.expandedSymbol;
    }

    public parseNumberOfExpandedSymbol(rawData: IHorribleHeroesServerData): number[] {
        this._numberOfExpandSymbolOnReel = [];
        rawData.symbolSizes.forEach((reelArr, reelId) => {
            let count = 0;
            reelArr.forEach((value: number) => {
                if (value) {
                    count++;
                }
                this._numberOfExpandSymbolOnReel[reelId] = count;
            });

        });
        return this._numberOfExpandSymbolOnReel;
    }

    public parseLockedWildWindow(rawData: IHorribleHeroesGameData): boolean[][] {
        return rawData.lockedWildWindow;
    }

    public parseLockedWildNextSpin(rawData: IHorribleHeroesGameData): boolean[][] {
        return rawData.lockedWildNextSpin;
    }

    public parseWildMultipliers(rawData: IHorribleHeroesServerData): number[][] {
        return rawData.wildMultipliers;
    }

    public parseGameAreaSizeAfter(rawData: IHorribleHeroesGameData): number[] {
        return rawData.gameAreaSizeAfter;
    }

    public parseReelsEnteringFreespin(rawData: IHorribleHeroesGameData) {
        if (rawData.reelsEnteringFreespin != undefined) {
            if (rawData.reelsEnteringFreespin[0][0]) {
                return ServerDataParser.parseStackedSymbolsInReels(rawData.reelsEnteringFreespin);
            }

        }
        return undefined;
    };

    public parseReels(rawData: IHorribleHeroesGameData) {
        if (rawData.reels[0] && rawData.reels[0][0]) {
            return ServerDataParser.parseStackedSymbolsInReels(rawData.reels);
        } else {
            if (rawData.reelsEnteringFreespin != undefined) {
                return ServerDataParser.parseStackedSymbolsInReels(rawData.reelsEnteringFreespin);
            } else {
                return ServerDataParser.parseStackedSymbolsInReels(rawData.reels);
            }
        }

    };

    public parseSymbolSizesPos(rawData: IHorribleHeroesGameData | IHorribleHeroesServerData) {
        let posArr: number[][] = [];
        this.infectiousPos = [[], [], [], [], []];
        this._mysterySymbolSizes = [-1, -1, -1, -1, -1];
        rawData.symbolSizes.forEach((reelArr, reelId) => {
            posArr[reelId] = [];

            this.infectiousPos[reelId] = [];
            for (let symIndex = 0; symIndex < 4; symIndex++) {
                if (reelArr[symIndex]) {
                    if (!(rawData.wildMultipliers[reelId][symIndex] > 0)) {
                        this._mysterySymbolSizes[reelId] = reelArr[symIndex];
                    }
                    if (this._numberOfExpandSymbolOnReel[reelId] > 1) {
                        if (rawData.XSymbolPositions[reelId] > -1 && (symIndex < rawData.XSymbolPositions[reelId])) {
                            //infected symbol is on top part
                            this.infectiousPos[reelId].push(symIndex);
                            posArr[reelId][1] = symIndex; //posArr[reelId][0] //should contain position  of  X;
                            posArr[reelId][0] = rawData.XSymbolPositions[reelId] + reelArr[symIndex] - 1; //posArr[reelId][0] //should contain position  of  X;
                            break;
                        } else {//two infected symbols on single reel
                            if (rawData.XSymbolPositions[reelId] > -1 && (symIndex > rawData.XSymbolPositions[reelId])) {
                                //X and infected symbols, X already on top
                                this.infectiousPos[reelId].push(symIndex + reelArr[symIndex] - 1);
                            }
                            if (posArr[reelId].length > 0) {
                                posArr[reelId].push(symIndex + reelArr[symIndex] - 1);
                            } else {
                                posArr[reelId].push(symIndex);
                            }

                        }
                    } else { //single X or single infected symbol
                        posArr[reelId].push(symIndex);
                    }
                    if (rawData.XSymbolPositions[reelId] == -1) {
                        //no X on this reel
                        this.infectiousPos[reelId].push(symIndex);
                    }
                }
            }
        });
        return posArr;
    }

    public parseInfectiousPos(): number[][] {
        return this.infectiousPos;
    }

    public parseMysterSymSize(): number[] {
        return this._mysterySymbolSizes;
    }

    public parseNonInfectedPos(mysteryPositions: number[][][], rawData: IHorribleHeroesGameData): number[][] {
        let nonInfectedPos: number[][] = [[], [], [], [], []];
        mysteryPositions.forEach((eachReel: (number[])[], reelID: number) => {
            nonInfectedPos[reelID] = [];
            if (this._numberOfExpandSymbolOnReel[reelID] > 0) {
                for (let symId = 0; symId < rawData.gameAreaSizeAfter[reelID]; symId++) {

                    if (!(this.isMysteryPosition(reelID, symId, mysteryPositions))) {
                        nonInfectedPos[reelID].push(symId);
                    }
                }
            }
        });
        return nonInfectedPos;
    }

    public parseMysteryPositions(symbolSizePos: number[][]): number[][][] {
        let mysteryPos: number[] = [];

        let mysteryPositions: number[][][] = [[], [], [], [], []];
        symbolSizePos.forEach((eachReel: number[], reelID: number) => {
            mysteryPositions[reelID] = [];

            eachReel.forEach(((symId: number) => {
                mysteryPos = this.getMysteryPositionsOnReel(reelID, symId);
                mysteryPositions[reelID].push(mysteryPos);
            }))
        });
        return mysteryPositions;
    }

    /* parseXWaysNonExpandingPos
        returns Positions Impacted due to XWays;
    * */
    public parseXWaysNonExpandingPos(mysteryPositions: number[][][], rawData: IHorribleHeroesGameData): number[][] {
        let xWaysNonExpandingPos: number[][] = [[], [], [], [], []];
        let xwaysReelSize = 4;

        rawData.symbolSizes.forEach((eachReel: number[], reelID: number) => {
            xWaysNonExpandingPos[reelID] = [];
            xwaysReelSize = 4;
            if (rawData.XWaysExpand[reelID]) {
                xwaysReelSize = 4 + this._mysterySymbolSizes[reelID] - 1;
            }
            if (rawData.numberOfExpandSymbolOnReel[reelID] > 0) {
                for (let symId = 0; symId < xwaysReelSize; symId++) {
                    if (this.infectiousPos[reelID][0] !== symId && this.infectiousPos[reelID][1] !== symId) {
                        if (!((mysteryPositions[reelID].length > 0) && mysteryPositions[reelID][0].indexOf(symId) > -1)) {
                            xWaysNonExpandingPos[reelID].push(symId);
                        }
                    }

                }
            }
        });
        return xWaysNonExpandingPos;
    }

    /**
     * @inheritDoc returns mysteryPostions affected considering only Xpositions
     * @param rawData -gameData
     */
    public parseMysteryXwaysPositions(rawData: IHorribleHeroesGameData): number[][][] {
        let mysteryPos: number[] = [];
        let mysteryPositions: number[][][] = [[], [], [], [], []];
        for (let reelID = 0; reelID < 5; reelID++) {
            const XPos = rawData.XSymbolPositions[reelID];
            mysteryPositions[reelID] = [];
            mysteryPos = [];
            if (rawData.XWaysExpand[reelID]) {
                for (let symId = XPos; symId < this._mysterySymbolSizes[reelID] + XPos; symId++) {
                    mysteryPos.push(symId);
                }
            }
            mysteryPositions[reelID].push(mysteryPos);
        }
        return mysteryPositions;
    }

    public parseFreespinSpinChoices(rawData: IHorribleHeroesServerData): number[] {
        return rawData.freespinSpinChoices;
    }

    public parseSuperFSTriggered(rawData: IHorribleHeroesServerData): boolean {
        return rawData.superFSTriggered;
    }

    public parseRandomWildFS(rawData: IHorribleHeroesGameData): boolean[][] {
        return rawData.randomWildFS;
    }

    public parseBrokeTheBank(rawData: IHorribleHeroesGameData): boolean {
        return rawData.brokeTheBank;
    }

    /**
     * @inheritDoc returns mysteryPositions affected considering only Xpositions
     * @param reelID
     * @param symId
     * @param mysteryPositions - including infected positions
     *
     */
    private isMysteryPosition(reelID: number, symId: number, mysteryPositions: number[][][]): boolean {
        if (mysteryPositions[reelID].length > 0) {
            if (mysteryPositions[reelID][0].indexOf(symId) > -1) {
                return true;
            }
            if (mysteryPositions[reelID].length > 1 && mysteryPositions[reelID][1].indexOf(symId) > -1) {
                return true;
            }
        }

        return false;
    }

    private getMysteryPositionsOnReel(reelId: number, symId: number): number[] {
        let mysteryPos: number[] = [];
        for (let posId = symId; posId < symId + this._mysterySymbolSizes[reelId]; posId++) {
            mysteryPos.push(posId);
        }
        return mysteryPos;
    }
}